export const API_BASE_URL = import.meta.env.VITE_API_URL ?? ""; // @runtime-env-ok — Vite build-time inlined, no CF Workers runtime secret

/**
 * Resolve a media URL returned by the API to an absolute URL.
 *
 * The AI image endpoint returns relative paths (`/api/ai/uploads/<file>.png`)
 * when a real key is present. Data URLs and absolute http(s) URLs pass through
 * unchanged. Relative paths are prefixed with API_BASE_URL so the browser can
 * fetch them from the correct origin regardless of where the app is deployed.
 */
export function mediaUrl(url: string): string {
  if (!url) return url;
  if (url.startsWith("data:") || url.startsWith("http")) return url;
  return `${API_BASE_URL}${url}`;
}
